module.exports = __webpack_public_path__ + "img/page.7c6ddcb5.png";